// Apply the brand/tag filter as soon as a checkbox is toggled, so the user
// doesn't have to click a separate confirm button. Selecting a super-brand
// lets brands.js tick its sub-brands first (on the input event), so they are
// included by the time the change event submits the form.
const form = document.getElementById('filterForm');

if (form) {
	form.addEventListener('change', function() {
		form.submit();
	});

	// The confirm button is redundant once changes auto-apply; hide it but
	// keep it in the markup as a no-JS fallback.
	const button = form.querySelector('.filter__button');
	if (button) {
		button.hidden = true;
	}
}
